/**
 * Runtime expansion of PCS grants before matching — same-stem weaker actions only.
 *
 * @rbac-mirror-revision 7
 */

const WEAKER_BY_STRONG: Record<string, readonly string[]> = {
  edit: ['view'],
  create: ['view'],
  delete: ['view'],
}

const LATTICE_ACTIONS = new Set(['view', 'create', 'edit', 'delete'])

function normalizeGrantKey(s: string): string {
  return s.trim()
}

export function parseGrantKeyForLatticeExpansion(key: string): { base: string; action: string } | null {
  const k = normalizeGrantKey(key)
  if (!k || k.includes('*')) return null
  const parts = k.split('.').filter(Boolean)
  if (parts.length !== 3) return null
  const action = parts[2]!
  if (!LATTICE_ACTIONS.has(action)) return null
  const base = `${parts[0]}.${parts[1]}`
  return { base, action }
}

export function expandUserGrantsForEvaluation(grants: readonly string[]): string[] {
  const out = new Set<string>()
  for (const raw of grants) {
    const g = normalizeGrantKey(raw)
    if (!g || g.includes('*')) continue
    out.add(g)
    const parsed = parseGrantKeyForLatticeExpansion(g)
    if (!parsed) continue
    const weaker = WEAKER_BY_STRONG[parsed.action]
    if (!weaker?.length) continue
    for (const w of weaker) {
      out.add(`${parsed.base}.${w}`)
    }
  }
  return [...out]
}
